// export const SERVER_URL = "http://192.168.1.192:30896"; // 开发环境
// export const DEVELOPMENT_SERVER_URL = "http://192.168.1.192:30896"; //开发环境

export const SERVER_URL = "https://jlbossapi.thussat.cn"; // 正式环境
export const DEVELOPMENT_SERVER_URL = "https://jlbossapi.thussat.cn"; //正式环境
